export default class Scroller {
    constructor(element) {
        this.element = element;
        this.activeIndex = 0;
        this.tutorialShown = false;
        this.dragMode = false;
        this.dragOffset = 0;
        this.dragPosition = 0;
        this.dragVelocity = 0;
        this.dragTimestamp = 0;
        this.list = this.element.querySelector('ul');
        if(this.list === null || this.list.children.length === 0) {
            throw "The hero slider needs to contain a UL containing at least one LI for slide content";
        }

        let slides = this.list.querySelectorAll('li');
        if(slides.length === 0) {
            throw "The hero slider needs to contain a UL containing at least one LI for slide content";
        }
        this.slides = slides

        this.updateItemWidth()

        let controlLeft = this.element.querySelector('.control--left');
        let controlRight = this.element.querySelector('.control--right');
        if(controlLeft) {
            controlLeft.addEventListener('click', () => {
                this.previous()
            })
        }
        if(controlRight) {
            controlRight.addEventListener('click', () => {
                this.next()
            })
        }
        this.controlIndicator = this.element.querySelector('.control__indicator');
        for(let i = 0; i < slides.length; i++){
            let indicatorDot = document.createElement('span')
            indicatorDot.classList.add('control__indicator__dot')
            this.controlIndicator.appendChild(indicatorDot)
        }
        this.controlIndicatorDots = this.element.querySelectorAll('.control__indicator__dot')
        this.controlIndicatorDots[this.activeIndex].classList.add('active')

        this.checkControlVisibility();
        document.addEventListener('scroll', () => {
            if(this.isInView()) {
                this.showTutorial();
            }
        })
        window.addEventListener('resize', () => {
            this.updateItemWidth();
            this.updateSliderPosition();
            this.checkControlVisibility();
        })
        window.addEventListener('redraw', () => {
            this.checkControlVisibility();
            this.updateSliderPosition();
            this.updateItemWidth();
        })

        this.element.addEventListener('touchstart', (event) => {
            this.startDragMode(event);
        })
        this.element.addEventListener('touchmove', (event) => {
            let x = event.touches[0].pageX;

            let now = Date.now();
            let timespan = now - this.dragTimestamp;
            let distance = x - this.dragPosition;

            this.dragVelocity = distance / timespan;
            this.dragPosition = x;
            this.dragTimestamp = now;

            this.updateSliderPosition(x - this.dragOffset);

            // If the velocity is greater than 1, lock scrolling
            if(Math.abs(this.dragVelocity) > 0.2) {
                this.disableBodyScroll()
            }
        })
        this.element.addEventListener('touchend', (event) => {
            this.stopDragMode(event);
            this.enableBodyScroll();
        })
    }
    updateItemWidth(){
        let slideStyle = window.getComputedStyle(this.slides[0]);
        this.itemPxWidth = parseInt(slideStyle.width) + parseInt(slideStyle.marginRight);
    }
    startDragMode(event){
        this.dragMode = true;
        this.dragOffset = event.touches[0].pageX;
        this.element.classList.add('drag-mode');
    }
    stopDragMode(event){
        this.dragMode = false;
        this.element.classList.remove('drag-mode');
        this.snapBackToNearestSlide();
    }
    snapBackToNearestSlide() {
        let currentPosition = this.getCurrentSlidePosition();

        // Also consider dragging velocity
        if(isFinite(this.dragVelocity)) {
            currentPosition += this.dragVelocity * 70;
        }

        let closestSlideIdx = 0;
        let closestDistance = null;

        for(let i = 0; i < this.slides.length; i++) {
            let slidePosition = this.getSlidePositionByIndex(i);
            let distance = Math.abs(currentPosition + slidePosition);
            if(closestDistance === null || distance < closestDistance) {
                closestDistance = distance;
                closestSlideIdx = i;
            }
        }

        this.activeIndex = closestSlideIdx;
        this.updateSliderPosition();
    }
    next(){
        if(this.activeIndex + 1 < this.slides.length){
            this.activeIndex = this.activeIndex + 1
            this.updateSliderPosition();
            this.setIndicatorActive()
        }
    }
    previous(){
        if(this.activeIndex - 1 >= 0){
            this.activeIndex = this.activeIndex - 1
            this.updateSliderPosition();
            this.setIndicatorActive()
        }
    }
    getCurrentSlidePosition() {
        return parseInt(this.list.style.marginLeft);
    }
    getSlidePositionByIndex(index) {
        return index * this.itemPxWidth;
    }
    updateSliderPosition(offset = 0) {
        this.list.style.marginLeft = -this.getSlidePositionByIndex(this.activeIndex) + offset + 'px';
    }
    setIndicatorActive(){
        for(let i = 0; i < this.slides.length; i++){
            if(i === this.activeIndex && !this.controlIndicatorDots[i].classList.contains('active')){
                this.controlIndicatorDots[i].classList.add('active')
            }
            if( i !== this.activeIndex && this.controlIndicatorDots[i].classList.contains('active')){
                this.controlIndicatorDots[i].classList.remove('active')
            }
        }
    }
    isInView() {
        var windowHeight = window.innerHeight;
        var elementYRelative = this.element.getBoundingClientRect().top;

        if(elementYRelative < windowHeight / 2) {
            return true;
        }
        return false;
    }
    showTutorial() {
        this.tutorialShown = true;

        this.element.classList.add('show-tutorial');
    }
    /**
     * If the size of items is equal or less to their container,
     * we don't need to slide anything so hide controls.
     */
    checkControlVisibility() {
        let offset = parseInt(window.getComputedStyle(this.list).marginLeft)
        let dimensions = this.list.getBoundingClientRect().width + offset;
        let scrollWidth = this.list.scrollWidth;

        if(dimensions >= scrollWidth) {
            return this.element.classList.add('teaser--no-control');
        }

        this.element.classList.remove('teaser--no-control')
    }
    disableBodyScroll(){
        document.body.classList.add('no-scroll');
    }
    enableBodyScroll(){
        document.body.classList.remove('no-scroll');
    }
}
